/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import OffsetSlider from 'components/sliders/OffsetSlider';
import { useLightbox } from 'hooks/useLightbox';

import GalleryItem from './components/Item';

import styles from './styles.module.scss';

const Gallery = ({
	materials,
	containerClassName,
	withLightbox,
	type,
	className,
	theme
}) => {
	const [lightbox, showLightbox] = useLightbox(materials);

	return (
		<div>
			<OffsetSlider
				className={cx(styles[`Gallery_theme_${theme}`], className)}
				containerClassName={containerClassName}
			>
				{materials.map((material, index) => (
					<div key={material._id} onClick={() => showLightbox(index)}>
						<GalleryItem material={material} type={type || material.type} />
					</div>
				))}
			</OffsetSlider>
			{withLightbox && lightbox}
		</div>
	);
};

Gallery.propTypes = {
	materials: PropTypes.arrayOf(
		PropTypes.shape({
			_id: PropTypes.number.isRequired,
			type: PropTypes.string
		})
	).isRequired,
	containerClassName: PropTypes.string,
	type: PropTypes.string,
	className: PropTypes.string,
	withLightbox: PropTypes.bool,
	theme: PropTypes.oneOf(['dark'])
};

Gallery.defaultProps = {
	withLightbox: false
};

export default Gallery;
